import { integration } from '@yola/ws-sdk';

const getStoreId = (rootState) => {
  const { userPreferences = {} } = integration.selectors.getSettings(rootState);

  return userPreferences.ecwidStoreId;
};

export default getStoreId;
